import * as universal from "../../../../src/routes/(app)/events/+page.ts";
export { universal };
export { default as component } from "../../../../src/routes/(app)/events/+page.svelte";